import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { SessionExpiredBanner } from "./SessionExpiredBanner";
import { ConsentGate } from "./ConsentGate";

export const ProtectedRoute = () => {
  const { user, loading } = useAuth();
  if (loading) return <div className="screen-center" data-testid="session-loading">Loading session…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  return (<><SessionExpiredBanner /><ConsentGate /><Outlet /></>);
};
